import React from 'react';
import styled from 'styled-components';
import { useAuth } from '@cnx-saas/react-auth';

const Hint = styled.div`
  background: ${({ theme }) => theme.palette.warning.light};
  color: ${({ theme }) => theme.palette.grey[900]};
  padding: 5px;
`;

const Position = styled.div`
  left: 50%;
  position: fixed;
  top: 0;
`;

function ImpersonationHint(): JSX.Element | null {
  const { impersonator } = useAuth(true);
  const isTokenImpersonated = Boolean(impersonator);

  return isTokenImpersonated ? (
    <Position>
      <Hint>Impersonated!</Hint>
    </Position>
  ) : null;
}

export { ImpersonationHint };
